import { Strategy } from 'src/api/types';

export const checkIsModifierStrategy = (strategy: Strategy | null) => {
  return strategy === 'Treat' || strategy === 'Transfer';
};
